// removed by extract-text-webpack-plugin
module.exports = {"NewRoom":"_3C7XjaaY4FLqrKB8xS759W","Error":"UGCMygHPv11agmgkSCDaG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rooms/NewRoom/NewRoom.css
// module id = 255
// module chunks = 0